import React from 'react';
import styled from '@emotion/styled';
import { X, CheckCircle } from 'lucide-react';

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #e5e7eb;
  background: #f8fafc;
  border-radius: 12px 12px 0 0;
`;

const HeaderLeft = styled.div`
  flex: 1;
`;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
`;

const ModalTitle = styled.h2`
  margin: 0;
  color: #111827;
  font-size: 1.5rem;
  font-weight: 600;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 6px;
  color: #6b7280;
  transition: all 0.2s;
  
  &:hover {
    background: #f3f4f6;
    color: #374151;
  }
`;

const FieldModalHeader = ({ fieldName, loanId, borrowerName, fieldPriority, onClose }) => {
  return (
    <ModalHeader>
      <HeaderLeft>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <ModalTitle>Field: {fieldName}</ModalTitle>
          {fieldPriority === 'critical' && (
            <div 
              style={{ 
                display: 'flex', 
                alignItems: 'center', 
                color: '#3b82f6',
                fontSize: '1.25rem',
                cursor: 'help'
              }}
              title="CRITICAL FIELD - This field requires immediate verification and must be validated with the highest level of accuracy. Any discrepancies must be resolved before loan processing can continue."
            >
              <CheckCircle size={20} />
            </div>
          )}
        </div>
        <div style={{ 
          fontSize: '0.75rem', 
          color: '#9ca3af', 
          fontWeight: '400',
          marginTop: '0.25rem'
        }}>
          {loanId} | {borrowerName}
        </div>
      </HeaderLeft>
      <HeaderRight>
        <CloseButton onClick={onClose}>
          <X size={20} />
        </CloseButton>
      </HeaderRight>
    </ModalHeader>
  );
};

export default FieldModalHeader;

